import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clock font-['GeneralSans-Bold'] leading-none" }
const _hoisted_2 = { class: "date font-['GeneralSans-Bold']" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.page)
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.time), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.date), 1)
  ], 2))
}